var map = {
	"./Group.svg": 564,
	"./Vector.svg": 7479,
	"./Vector1.svg": 6688,
	"./Vector2.svg": 8715,
	"./emblem.svg": 3716,
	"./iconfinder.svg": 5356,
	"./servicesDesc/2chela_sidyat.svg": 8194,
	"./servicesDesc/Chel_stoit.svg": 120,
	"./servicesDesc/undraw.svg": 1326,
	"./servicesDesc/undraw_artificial_intelligence_re_enpp.svg": 8955,
	"./servicesDesc/undraw_design_team_re_gh2d.svg": 7858,
	"./servicesDesc/undraw_investor_update_re_qnuu.svg": 2889,
	"./servicesDesc/undraw_online_stats_0g94.svg": 2525,
	"./servicesDesc/undraw_security_re_a2rk.svg": 4787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2757;